module.exports = "<app-poi-edit-photos poi=$ctrl.poi on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-poi-edit-photos> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/photos/template.html
// module id = 441
// module chunks = 0